import {Globals} from "./Globals";
import {Notification} from "../components/commond/Notification";
import React from "react";
import {cuppa, log} from "../../cuppa/cuppa";
import {OrganizationCtrl} from "./OrganizationCtrl";
import {Utils} from "./Utils";
import {ConversationsCtrl} from "./ConversationsCtrl";

export class NotificationCtrl{
	static add({title, message, closeText = "Close", openText = "Open", closeCallback, openCallback, hoverAvoidAutoClose = true}){
		let refName = cuppa.unique('notification_');
		Globals.notificationPortal.add(refName,
			<Notification
				key={refName}
				title={title}
				closeText={closeText}
				openText={openText}
				message={message}
				removeCallback={()=>{ Globals.notificationPortal.remove(refName); }}
				openCallback={openCallback}
				closeCallback={closeCallback}
				hoverAvoidAutoClose={hoverAvoidAutoClose}
			/>
		);
		return refName;
	}

	static async showNewConversationMessage(data) {
		let conversation = await ConversationsCtrl.loadConversation({id:data?.conversation?.id});
			conversation = conversation?.data?.conversation;
		if(!conversation) return;
		let organizationId = data?.conversation?.organization_id;
		if (organizationId && organizationId != OrganizationCtrl.getOrganization().id) return;
		if (cuppa.urlValue("ref") == data?.conversation?.id && cuppa.urlValue("tab") === "chat") return;
		let title = `Case ${data?.conversation?.id}`;
			if(conversation?.description) title += ` - ${conversation?.description}`;
		const message = cuppa.cutText(' ', data?.messageData?.message, 80, '...');
		NotificationCtrl.add({title, message, openCallback:()=>{
			Utils.redirect(`/conversations/conversation/?ref=${data?.conversation?.id}&tab=chat`, {forcePath:true})
		}});
	}
}
